'use strict';

angular.module('ClinicApp').directive('screenshotViewer', function(OCDomUtil) {
  return {
    templateUrl: '/views/directives/_screenshot-viewer.html',
    scope: {
      imageUrl: '=screenshotViewer',
      onClose: '&',
    },
    link: function(scope) {
      OCDomUtil.addOverlayBodyClass(scope);

      scope.stopPropagation = function(e) {
        e.stopPropagation();
      };

      var keyHandler = function(e) {
        if (e.originalEvent.keyCode == 27) { // ESC
          scope.onClose();
          scope.$apply();
        }
      };

      var $doc = angular.element(document);

      $doc.on('keydown', keyHandler);
      scope.$on('$destroy', function() {
        $doc.off('keydown', keyHandler);
      });
    },
  };
});
